// extracted by mini-css-extract-plugin
export default {"customPageContainer":"CreateCustomPage_customPageContainer__4eBDb","saveButton":"CreateCustomPage_saveButton__aA5qf"};